/* eslint-disable */
/* global screen, window */

import bowser from 'bowser';

const browser = bowser.getParser(window.navigator.userAgent);

export const ios = browser.parsedResult.os.name === 'iOS';
export const safari = browser.parsedResult.browser.name === 'Safari';
export const mobile = browser.parsedResult.platform.type === 'mobile';
export const iphoneX = (parseInt(screen.availHeight) === 812) && // eslint-disable-line no-mixed-operators, max-len
    (parseInt(screen.availWidth) === 375) || // eslint-disable-line no-mixed-operators
    ((parseInt(window.innerHeight) === 375) && // eslint-disable-line no-mixed-operators
    (parseInt(window.innerWidth) === 812)); // eslint-disable-line no-mixed-operators
